import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavItemLink } from '../components/item/NavItem';
import styles from './nav_public_pricing.module.scss';

export function NavPublicPricing() {
  return (
    <NavItemLink
      className={styles.container}
      href="/tarifs"
      source="nav"
      title="Tarifs"
    >
      <FormattedMessage id="navigation/pricing/NavPublicPricing.tsx/1" />
    </NavItemLink>
  );
}
